<div class="dialog-content">
  <h1 mat-dialog-title>
    {{ data?.title | translate }}
  </h1>
  <div mat-dialog-content>
    <div>
      <ui-list-filter
        [filtersConfig]="filterConfig"
        (filtersChange)="fetchListBySearchCriteria($event)"
      ></ui-list-filter>
      <mat-table [dataSource]="dataSource" multiTemplateDataRows noDataTableMessage>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.name' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tw-flex tw-justify-between tw-items-center tw-box-border">
            <span>{{ element.name }}</span>
            <span *ngIf="element.isDefault" class="item-status">{{ 'common.field.default' | translate }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.description' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.description }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="hub">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.hub' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngFor="let hub of hubContextFacade.activeItems$ | async">
              <span *ngIf="element?.driverViewHubId === hub.id"> {{ hub.name }}</span>
            </ng-container>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          class="pointer"
          *matRowDef="let row; columns: displayedColumns"
          (click)="dialogRef.close(row)"
        ></mat-row>
      </mat-table>

      <mat-paginator #paginator> </mat-paginator>
    </div>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
  </div>
</div>
